import { useAuth0 } from "@auth0/auth0-react";

export const useUserEmail: () => string | undefined = () => {
  const { user } = useAuth0();
  return user?.email;
};
